module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Light.cbdbc775.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Light.woff
// module id = 933
// module chunks = 0